import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import { Divider } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';
import Article from './article';

class ArticleList extends Component {
  render() {
    const { classes } = this.props;

    const articles = this.props.value.map((a, i) => {
      const divider = i === this.props.value.length - 1 ? null : <Divider light />;
      return (
        <div key={a.name}>
          <ListItem>
            <Article value={a} />
          </ListItem>
          {divider}
        </div>
      );
    });

    return (
      <div className={classes.root}>
        <List dense>
          {articles}
        </List>
      </div>
    );
  }
}

const styles = () => ({
  root: {
  },

});

ArticleList.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired,
};

ArticleList.defaultProps = {
  articles: [],
};

export default withStyles(styles)(ArticleList);
